import { jsx, css } from '@emotion/react';
import { Button } from '@zapier/design-system';
import { UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH } from '../../../../universal-nav/constants';
import { boxSizing } from '../../../../utils/style-mixins/reset';
const styles = css(Object.assign(Object.assign({}, boxSizing), { 'a, button': {
        font: `var(--zds-body-3) !important`,
        height: 'var(--zds-size-36, 36px) !important',
        borderRadius: 'var(--zds-radius-large, 8px) !important',
        color: 'var(--zds-text-inverted, #FFFDF9) !important',
        borderColor: 'var(--zds-ui-brand, #FF4F00) !important',
        '&[data-size="small"]': {
            '[data-testid="iconContainer"]': {
                height: '20px !important',
                width: '20px !important',
            },
        },
    }, 'a:focus:not([disabled])::before, a:focus': {
        borderRadius: 'var(--zds-radius-large, 8px) !important',
    }, [`@container (max-width: ${UNIVERSAL_SIDEBAR_COLLAPSED_WIDTH}px)`]: {
        span: {
            padding: '0 !important',
            margin: '0 !important',
        },
        '.hiddenWhileCollapsed': {
            display: 'none',
        },
    }, 'button:hover:not(:focus-visible)': {
        backgroundColor: 'var(--zds-ui-brand-stronger, #CC3F00) !important',
        borderColor: 'var(--zds-ui-brand-stronger, #CC3F00) !important',
        boxShadow: 'none !important',
    }, 'button:focus-visible::before': {
        border: 'var(--zds-border-focus, 2px solid #695BE8) !important',
        borderRadius: 'var(--zds-radius-small, 3px) !important',
    } }));
const InAppSidebarSubheaderButton = (props) => {
    return (jsx("div", { className: "sidebar-create-menu-button", css: styles, "data-zds": true },
        jsx(Button, { "aria-label": props.text, iconBefore: props.iconName, href: props.href, isFullWidth: true, onClick: props.onClick, size: "small", color: "brand" },
            jsx("span", { className: "hiddenWhileCollapsed", "data-a11y-ignore": "color-contrast" }, props.text))));
};
export default InAppSidebarSubheaderButton;
//# sourceMappingURL=InAppSidebarSubheaderButton.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
